export enum GroupTags {
    REMOVED = "Removed",
    READ_ONLY = "Read Only",
    NEW = "New",
}
